export default __webpack_public_path__ + "static/media/cardLogo.c6a02c1e.svg";